import React from "react"
import styled from "styled-components"

import { FLEX_CENTER } from "styles/settings"
import CircularProgress from "@rentspree/component-2023.components.organisms.circular-progress"

export const StyledLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  ${FLEX_CENTER};
  background: rgba(255, 255, 255, 0.8);
  height: 100%;
  width: 100%;
  z-index: 3;
  ${props => props.column && "flex-direction: column"};
`

export const OverlayLoading = ({
  background,
  column,
  children,
  iconMargin,
  dataTestId
}) => (
  <StyledLoading
    data-testid={dataTestId}
    style={{ background }}
    column={column}>
    <CircularProgress
      color="black"
      size={column ? "icon" : "medium"}
      data-testid="loading"
      sx={{ margin: iconMargin }}
    />
    {children && children}
  </StyledLoading>
)
